import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';
import { DEFINITIONS, SCORING_SCALE } from '../content/definitions';

export function HelpPage() {
  return (
    <article className="prose prose-slate mx-auto max-w-3xl">
      <h1>Definitions</h1>
      <p className="lead">
        Flow ranks items by WSJF — Cost of Delay divided by Job Size. The four
        scoring dimensions feed Cost of Delay; the fifth (Confidence) annotates
        how sure you are.
      </p>
      {DEFINITIONS.map((d) => (
        <section key={d.id} id={d.id}>
          <h2>{d.title}</h2>
          <p className="italic text-slate-600">{d.shortHelp}</p>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{d.body}</ReactMarkdown>
        </section>
      ))}
      <section id="scoring-scale">
        <h2>{SCORING_SCALE.title}</h2>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{SCORING_SCALE.body}</ReactMarkdown>
      </section>
      <p>
        <Link to="/portfolio">← Back to Portfolio</Link>
      </p>
    </article>
  );
}
